import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/LoginPage.vue'
import ProductsList from "@/pages/ProductsListPage";
import ProductForm from "@/pages/EditProductPage";
import ProfilePage from "@/pages/ProfilePage";
import AddProduct from "@/pages/AddProduct";
import DocumentsPage from "@/pages/DocumentsPage";
import JobsPage from "@/pages/JobsPage";
import platformSettings from '~config/settings'
import ActivationPage from '@/pages/ActivationPage'

import auth from '@/middleware/authenticated'
import HomePage from "../pages/HomePage.vue";
import SavePayment from "@/pages/Buyer/SavePayment";
import PaymentAdded from "@/pages/Buyer/PaymentAdded";

Vue.use(VueRouter)


function setPageTitle(to){
  const DEFAULT_TITLE = platformSettings.shopTitle ||  platformSettings.platformOwner  + ' Verkäufer-Portal';
  Vue.nextTick(() => {document.title = to.meta.title || DEFAULT_TITLE})
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: platformSettings.platformOwner + ' Verkäufer-Portal',
      middleware: auth
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: platformSettings.platformOwner + ' Verkäufer-Portal Login',
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsList,
    meta: {
      middleware: auth
    }
  },
  {
    path: '/add_product',
    name: 'Add product',
    component: AddProduct,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/products/:id",
    name: 'ProductForm',
    component: ProductForm,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/profile",
    name: 'ProfilePage',
    component: ProfilePage,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/documents",
    name: "Documents",
    component: DocumentsPage,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: JobsPage,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/activate",
    name: "Activate",
    component: ActivationPage,
    meta: {
      title: platformSettings.platformOwner + ' Verkäufer-Portal Aktivierung',
    }
  },
  {
    path: "/stripe/save_payment",
    name: "Save Stripe Payment",
    component: SavePayment,
  },
  {
    path: "/stripe/success",
    name: "Payment Saved",
    component: PaymentAdded,
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next
  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
        ? to.meta.middleware
        : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }
  return next()
})



router.afterEach(setPageTitle);

export default router
